import { createFileRoute } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { getActiveSupplyPoint } from '@/features/supply-points/utils/resolveActiveSupplyPoint';
import { deviceQueries } from '@/features/devices/queries';
import { EditDevicePage } from '@/features/devices/pages/EditDevicePage';
import { DetailsPageSkeleton } from '@/common/components/loading-skeleton/DetailsPageSkeleton';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/devices/$deviceId/edit')({
  parseParams: ({ deviceId }) => ({ deviceId: Number(deviceId) }),
  stringifyParams: ({ deviceId }) => ({ deviceId: String(deviceId) }),
  component: EditDeviceRouteComponent,
  pendingComponent: DetailsPageSkeleton,
  loader: async ({ context: { queryClient }, params }) => {
    const activeSupplyPoint = await getActiveSupplyPoint(queryClient);

    const promises: Promise<unknown>[] = [queryClient.ensureQueryData(deviceQueries.types())];

    if (activeSupplyPoint) {
      promises.push(queryClient.ensureQueryData(deviceQueries.list()));
    }

    promises.push(queryClient.ensureQueryData(deviceQueries.detail(params.deviceId)));
    promises.push(queryClient.ensureQueryData(deviceQueries.parameters(params.deviceId)));

    await Promise.all(promises);

    return { breadcrumb: t`Edit Device` };
  },
});

function EditDeviceRouteComponent() {
  const { deviceId } = Route.useParams();
  return <EditDevicePage deviceId={deviceId} />;
}
